import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { GetSignalsResponseDataSchema } from "schema"
import z from "zod"
import { getSignalsQueryKey } from "../lib/signalsQuery"

type Params = {
  signalIds: string[]
  isSolved: boolean
}

type Props = {
  onSuccess?: (response: z.infer<typeof GetSignalsResponseDataSchema>) => void
  onError?: (error: Error) => void
}

export function useSolveSignalsMutation({ onSuccess, onError }: Props) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ signalIds, isSolved }: Params) => {
      const { data } = await axios.post(`/insights/signals/solve`, { signalIds, isSolved })
      return data.data
    },
    onSuccess: (response) => {
      onSuccess?.(response)
      queryClient.invalidateQueries({ queryKey: getSignalsQueryKey() })
    },
    onError: (error) => {
      onError?.(error)
    },
  })
}
